import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyOrganisationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyOrganisationsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, organisationMember?: Array<{ __typename?: 'MemberOfOrganisation', role: Types.OrganisationRole, organisation: { __typename?: 'Organisation', name: string, uuid: string } }> | null } };


export const MyOrganisationsDocument = gql`
    query MyOrganisations {
  currentUser {
    id
    organisationMember {
      role
      organisation {
        name
        uuid
      }
    }
  }
}
    `;

/**
 * __useMyOrganisationsQuery__
 *
 * To run a query within a React component, call `useMyOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyOrganisationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<MyOrganisationsQuery, MyOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyOrganisationsQuery, MyOrganisationsQueryVariables>(MyOrganisationsDocument, options);
      }
export function useMyOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyOrganisationsQuery, MyOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyOrganisationsQuery, MyOrganisationsQueryVariables>(MyOrganisationsDocument, options);
        }
// @ts-ignore
export function useMyOrganisationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MyOrganisationsQuery, MyOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<MyOrganisationsQuery, MyOrganisationsQueryVariables>;
export function useMyOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyOrganisationsQuery, MyOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<MyOrganisationsQuery | undefined, MyOrganisationsQueryVariables>;
export function useMyOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyOrganisationsQuery, MyOrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyOrganisationsQuery, MyOrganisationsQueryVariables>(MyOrganisationsDocument, options);
        }
export type MyOrganisationsQueryHookResult = ReturnType<typeof useMyOrganisationsQuery>;
export type MyOrganisationsLazyQueryHookResult = ReturnType<typeof useMyOrganisationsLazyQuery>;
export type MyOrganisationsSuspenseQueryHookResult = ReturnType<typeof useMyOrganisationsSuspenseQuery>;
export type MyOrganisationsQueryResult = Apollo.QueryResult<MyOrganisationsQuery, MyOrganisationsQueryVariables>;